/**
 * Máscara de telefone brasileiro: (DD) XXXXX-XXXX (celular) ou (DD) XXXX-XXXX (fixo).
 * DDD: 2 dígitos. Celular: 9 dígitos. Fixo: 8 dígitos.
 */
export function formatBrazilianPhone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  if (digits.length <= 2) return digits ? `(${digits}` : ''
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
  if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
}

/** Aplica a máscara ao valor e retorna o resultado formatado. */
export function applyPhoneMask(value: string): string {
  return formatBrazilianPhone(value)
}

/** Retorna apenas os dígitos do telefone (para comparação). */
export function getPhoneDigits(value: string): string {
  return value.replace(/\D/g, '')
}
